module.exports = __webpack_public_path__ + "static/media/dimensions.d29e1de5.pdf";